<script lang="ts">
    import logo from "./Reteyn_WhiteBG.png";
</script>
<style>
</style>
<div class="w-20 h-6">
    <img class="object-cover" src={logo} alt="Reteyn logo" aria-label="Reteyn logo"/>
</div>

